import { useContext, useEffect } from 'react';
import PurchaseButton from '../purchase-button/purchase-button.component';
import SpreedlyContext from 'components/payment/spreedly/spreedly.context';

const GiftCardSpreedlyPurchaseButton303942 = ({
  processOrder,
  disabled,
  cardInfo,
  paymentLoading,
  setPaymentLoading,
}) => {
  const { submitSpreedlyForm } = useContext(SpreedlyContext);

  const onClick = () => {
    submitSpreedlyForm();
  };

  useEffect(() => {
    if (!cardInfo) return;
    processOrder(cardInfo.token);
    setPaymentLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardInfo]);

  return (
    <PurchaseButton disabled={paymentLoading || disabled} onClick={onClick} />
  );
};

export default GiftCardSpreedlyPurchaseButton303942;
